<template>
  <div class="menu_list">
    <div class="loan-list-container" v-infinite-scroll="load" :infinite-scroll-disabled="disabledScroll"
      infinite-scroll-distance="80">
      <div v-for="(item, index) in loanList" :key="`loan-${index}`" class="loan-item" @click="handleApply(item)">
        <div class="loan-header">
          <span class="loan-title">{{ item.title }}</span>
          <div class="approval-tag">
            <div class="tag-content">
              <div class="approval-text">极速审批</div>
            </div>
          </div>
        </div>
        <div class="loan-content">
          <img :src="'/api/admin/file/get?ossFilePath='+item.logoUrl" class="loan-logo" />
          <div class="loan-info">
            <div class="info-item">
              <span class="amount">{{ item.changeMoney }}</span>
              <!-- <span class="unit">万元</span> -->
            </div>
            <div class="info-item">
              <van-icon name="play" color="#F1E3CF" />
              <span>年化利率：{{ item.changeRate }}</span>
            </div>
            <div class="info-item">
              <van-icon name="play" color="#F1E3CF" />
              <span>贷款期限：{{item.changeTime}}</span>
            </div>
            <div class="info-item">
              <van-icon name="play" color="#F1E3CF" />
              <span>{{ item.creditTypeName }}</span>
            </div>
          </div>
          <!-- <div class="action-btn">
            <button @click="handleApply(item)">立即申请</button>
          </div> -->
        </div>
      </div>
      <div class="loading-status">
        <div v-if="loading" class="loading-text">
          <van-loading type="spinner" size="20px" />
          <span>加载中...</span>
        </div>
        <div v-if="noMore" class="no-more-text">没有更多数据了</div>
      </div>
    </div>
  </div>
</template>

<script>
  import { recordInquiry, ScreeningCondition } from "@/api/RuralFinance";
  import { Loading } from 'vant';
  export default {
    name: "LoanList",
    components: {
      [Loading.name]: Loading
    },
    data() {
      return {
        loanList: [], // 重命名为更具语义化的名称
        query: {
          pnum: 1,
          psize: 5,
        },
        loading: false,
        noMore: false,
        // 其他数据保持不变
        identityObj: {},
        accessToken: '',
        userId: '',
      };
    },
    computed: {
      disabledScroll() {
        return this.loading || this.noMore;
      }
    },
    mounted() {
      this.hideHeaderFooter();
      this.initParams();
      // this.initWeChat();
    },
    methods: {
      // 隐藏头部和底部
      hideHeaderFooter() {
           //隐藏头部和底部
    // const header = document.querySelector(".header"); 
    // const noShow = document.querySelector(".noShow");
    // const footer = document.querySelector(".footer-web");

      const homeManage = document.querySelector(".home-manage");

        // if (header) header.style.display = "none";
        // if (footer) footer.style.display = "none";
        // if (noShow) noShow.style.display = "none";
        if (homeManage) homeManage.style.paddingTop = "0";
      },

      // 获取数据
      async getData() {
        if (this.loading || this.noMore) return;

        try {
          this.loading = true;
          const params = {
            ...this.query,
            status: 1,
            areaCode: this.identityObj.areaCode?.areaCode || '',
          };

          const res = await recordInquiry(params);
          if (!res.status) return;

          await this.processLoanData(res.data);
          this.updateLoanList(res.data);
        } catch (error) {
          console.error('获取贷款数据失败:', error);
        } finally {
          this.loading = false;
        }
      },

      // 处理贷款数据
      async processLoanData(data) {
        const creditTypes = await this.getCreditTypes();
        if (!creditTypes) return;

        data.forEach(item => {
          this.processCreditType(item, creditTypes);
          this.processMoneyAmount(item);
          this.processLoanPeriod(item);
          this.processRate(item)
        });
      },
      //贷款利率
      processRate(item) {
        let changeRate = '';
        if (item.minRate != 0 && item.maxRate != 0 && item.minRate != item.maxRate) {
          changeRate = item.minRate + '%' + '~' + item.maxRate + '%';
        } else if (item.minRate != 0 && item.maxRate != 0 && item.minRate == item.maxRate) {
          changeRate = item.minRate + '%';
        } else if (item.minRate != 0 && item.maxRate == 0) {
          changeRate = item.minRate + '%起';
        } else if (item.minRate == 0 && item.maxRate != 0) {
          changeRate = '最高' + item.maxRate + '%';
        }
        item.changeRate = changeRate;
      },
      // 获取贷款类型
      async getCreditTypes() {
        try {
          const res = await ScreeningCondition("credit_type");
          return res.code === 0 ? res.data : null;
        } catch (error) {
          console.error('获取贷款类型失败:', error);
          return null;
        }
      },

      // 处理贷款类型
      processCreditType(item, creditTypes) {
        const types = item.creditType.split(",");
        const typeNames = types
          .filter(type => creditTypes.find(t => t.value === type))
          .map(type => creditTypes.find(t => t.value === type).label)
          .join('、');
        item.creditTypeName = typeNames;
      },

      // 处理贷款期限
      processLoanPeriod(item) {
        let changeTime = '';
        if (item.minTime != 0 && item.maxTime != 0 && item.minTime != item.maxTime) {
          changeTime = item.minTime + '个月' + '~' + item.maxTime + '个月';
        } else if (item.minTime != 0 && item.maxTime != 0 && item.minTime == item.maxTime) {
          changeTime = item.minTime + '个月';
        } else if (item.minTime != 0 && item.maxTime == 0) {
          changeTime = item.minTime + '个月起';
        } else if (item.minTime == 0 && item.maxTime != 0) {
          changeTime = '最高' + item.maxTime + '个月';
        }
        item.changeTime = changeTime;
      },

      // 处理金额
      processMoneyAmount(item) {
        // 处理最小金额
        if (item.minMoney >= 10000) {
          item.ToMinMoney = (item.minMoney / 10000) + "万元";
        } else if (item.minMoney < 10000) {
          item.ToMinMoney = item.minMoney + "元";
        }

        // 处理最大金额
        if (item.maxMoney >= 10000) {
          item.ToMaxMoney = (item.maxMoney / 10000) + "万元";
        } else {
          item.ToMaxMoney = item.maxMoney + "元";
        }

        // 根据条件组合显示金额
        let changeMoney = '';
        if (item.minMoney != 0 && item.maxMoney != 0 && item.minMoney != item.maxMoney) {
          changeMoney = item.ToMinMoney + '~' + item.ToMaxMoney;
        } else if (item.minMoney != 0 && item.maxMoney != 0 && item.minMoney == item.maxMoney) {
          changeMoney = item.ToMinMoney;
        } else if (item.minMoney != 0 && item.maxMoney == 0) {
          changeMoney = item.ToMinMoney + '起';
        } else if (item.minMoney == 0 && item.maxMoney != 0) {
          changeMoney = '最高' + item.ToMaxMoney;
        }

        // 保存处理后的金额
        item.changeMoney = changeMoney;
      },

      // 更新贷款列表
      updateLoanList(newData) {
        if (this.query.pnum === 1) {
          this.loanList = newData;
        } else {
          this.loanList = [...this.loanList, ...newData];
        }
        this.noMore = newData.length < this.query.psize;
      },

      // 加载更多
      load() {
        this.query.pnum++;
        this.getData();
      },

      // 处理申请
      handleApply(item) {
        console.log({
            financeProductId: item.financeProductId,
            identityObj: this.identityObj,
            userId: this.userId,
            accessToken: this.accessToken,
          }, 'item');
        
        this.$router.push({
          name: 'wxf',
          query: {
            financeProductId: item.financeProductId,
            identityObj: this.identityObj,
            userId: this.userId,
            access_token: this.accessToken,
          }
        });
      },

      // 初始化参数
      async initParams() {
        const queryParams = this.$route.query;
        Object.assign(this, {
          identityObj: queryParams.identityObj,
          userId: queryParams.userId,
          accessToken: queryParams.access_token,

        });
        await this.getData();
      },
    }
  };
</script>

<style lang="less" scoped>
  .menu_list {
    width: 100vw;
    height: 100vh;
    background: #f2f2f2;
  }

  .loan-list-container {
    background-color: #f5f9f8;
    height: 100vh;
    overflow: auto;
    padding: 10px;
  }

  .loan-item {
    background: white;
    margin-bottom: 10px;
    border-radius: 8px;
    padding: 15px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  .loan-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;

    .loan-title {
      font-size: 18px;
      font-weight: bold;
      color: #333;
    }

    .approval-tag {
      background-color: #f3eadb;
      border-radius: 15px;
      padding: 5px 10px;

      .approval-text {
        color: #a08926;
        font-size: 14px;
      }
    }
  }

  .loan-content {
    display: flex;
    align-items: center;

    .loan-logo {
      width: 80px;
      height: 80px;
      border-radius: 8px;
      margin-right: 15px;
    }

    .loan-info {
      flex: 1;

      .info-item {
        display: flex;
        align-items: center;
        margin-bottom: 8px;
        font-size: 14px;
        color: #666;

        .amount {
          font-size: 20px;
          font-weight: bold;
          color: #d25731;
          margin-right: 5px;
        }

        .unit {
          color: #d25731;
        }
      }
    }

    .action-btn {
      button {
        background: #000;
        color: white;
        border: none;
        padding: 8px 20px;
        border-radius: 25px;
        cursor: pointer;
        font-size: 14px;
        transition: background-color 0.3s;

        &:hover {
          background: #333;
        }
      }
    }
  }

  .loading-status {
    text-align: center;
    padding: 10px 0;

    .loading-text {
      display: flex;
      align-items: center;
      justify-content: center;
      color: #999;

      span {
        margin-left: 8px;
      }
    }

    .no-more-text {
      color: #999;
    }
  }
</style>
